import BEM from 'bem.js';
import toArray from 'arrayify';


const BLOCK_EXPOSITION_PRICES = 'exposition-prices';

const ELEMENT_ITEM = 'item';
const ELEMENT_ADD = 'add';
const ELEMENT_SUBTRACT = 'subtract';
const ELEMENT_INPUT = 'input';


export default class Buttons {
    constructor() {
        let items = BEM.getBEMNodes(BLOCK_EXPOSITION_PRICES, ELEMENT_ITEM);
        for(let item of toArray(items)) {
            this.addButtonEvent(item);
        }
    }

    addButtonEvent(item) {
        let input = BEM.getChildBEMNode(item, BLOCK_EXPOSITION_PRICES, ELEMENT_INPUT);
        let addButton = BEM.getChildBEMNode(item, BLOCK_EXPOSITION_PRICES, ELEMENT_ADD);
        let subtractButton = BEM.getChildBEMNode(item, BLOCK_EXPOSITION_PRICES, ELEMENT_SUBTRACT);

        addButton.addEventListener('click', (event) => {
            event.preventDefault();

            let value = Number(input.value);
            value += 1;
            input.value = value;
            this.fireEvent(input);
        });

        subtractButton.addEventListener('click', (event) => {
            event.preventDefault();

            let value = Number(input.value);
            value -= 1;
            if(value < 0) {
                return;
            }
            input.value = value;
            this.fireEvent(input);
        });
    }

    fireEvent(input) {
        if ('createEvent' in document) {
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', false, true);
            input.dispatchEvent(evt);
        } else {
            input.fireEvent('onchange');
        }
    }
}



// WEBPACK FOOTER //
// ./src/my_artis/js/views/exposition/buttons.js